/*
 * Puts the product named by ?first= at the front of a collection grid.
 *
 * Used by ad and email links of the form:
 *   /collections/premium-shirts?first=just-breathe-dandelion-tee
 *   /collections/sweatshirts?first=just-breathe-dandelion-sweatshirt
 *   /collections/hoodies?first=just-breathe-dandelion-hoodie
 *   /collections/long-sleeve-tees?first=just-breathe-dandelion-long-sleeve-tee
 *
 * Meta catalog (dynamic product) ads use the same scheme with the whole
 * catalog product URL packed into the param, via the creative's URL template:
 *   https://lotus-moon.co/collections/{collection}?first={{product.url | urlencode}}
 * which lands as
 *   /collections/hoodies?first=https%3A%2F%2Flotus-moon.co%2Fproducts%2Fpeace-hoodie%3Futm_content%3D...%26variant%3D123&fbclid=...
 * handleFromPath() pulls the product handle out of that full URL, so the same
 * template works for any product set: point {collection} at the matching
 * collection (premium-shirts, sweatshirts, hoodies, long-sleeve-tees).
 *
 * Handle and collection agnostic: any collection page that uses the
 * main-collection-product-grid section gets this for free, so new product
 * lines need no changes here. Verified live on all four collections above,
 * with bare handles and with the encoded catalog-ad form.
 *
 * This runs client side on purpose. Liquid cannot read arbitrary query params,
 * and the content_for_header "pageurl" workaround this replaced was unreliable:
 * Shopify reuses that blob across requests, so the featured card was frequently
 * missing, or worse, showed another visitor's product.
 *
 * The card is always fetched from the product.card template and added at the
 * front. If the product also sits further down the grid it stays there too, so
 * it shows twice on purpose; the collection order is left untouched. The
 * fetched card renders with its own section id, so its element ids never clash
 * with the original card's.
 */
(function () {
  'use strict';

  var PRODUCTS_PATH = '/products/';
  var HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;
  var FEATURED_ATTRIBUTE = 'data-first-product';

  function handleFromPath(value) {
    var path = String(value).split('#')[0].split('?')[0];
    var index = path.indexOf(PRODUCTS_PATH);
    if (index !== -1) path = path.slice(index + PRODUCTS_PATH.length);
    return path.replace(/^\/+/, '').split('/')[0].toLowerCase();
  }

  function requestedHandle() {
    var match = /[?&]first=([^&#]*)/.exec(window.location.search);
    if (!match) return '';

    var value = match[1].replace(/\+/g, ' ');
    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // Malformed encoding, fall through with the raw value.
    }

    var handle = handleFromPath(value.trim());
    return HANDLE_PATTERN.test(handle) ? handle : '';
  }

  function fetchCard(grid, handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=card')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var markup = html.trim();
        // The template renders the card and nothing else, so a response that
        // does not link to this product means the handle resolved elsewhere.
        if (!markup || markup.indexOf(PRODUCTS_PATH + handle) === -1) return;
        if (grid.querySelector('[' + FEATURED_ATTRIBUTE + ']')) return;

        var item = document.createElement('li');
        item.className = 'grid__item';
        item.setAttribute(FEATURED_ATTRIBUTE, handle);
        item.innerHTML = markup;
        grid.insertBefore(item, grid.firstElementChild);
      })
      .catch(function () {
        // No featured card is better than a broken one; the grid stands as is.
      });
  }

  function run() {
    var handle = requestedHandle();
    if (!handle) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    fetchCard(grid, handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
